import { render, staticRenderFns } from "./unit-info.vue?vue&type=template&id=182befc1&scoped=true"
import script from "./unit-info.ts?vue&type=script&lang=ts&external"
export * from "./unit-info.ts?vue&type=script&lang=ts&external"
import style0 from "./unit-info.less?vue&type=style&index=0&id=182befc1&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182befc1",
  null
  
)

export default component.exports